import PropTypes from "prop-types";

/**
 * Sélecteur "hologramme fixe / manipulable".
 * `value` : booléen (true = manipulable). `onChange` reçoit un booléen.
 */
const HologramModeSelect = ({
  value,
  onChange,
  className = "form-select form-select-sm mt-2",
  fixedTitle = "L'hologramme de la question remplace temporairement l'hologramme principal.",
  interactableTitle = "L'hologramme de la question est manipulable par l'utilisateur.",
}) => (
  <select
    className={className}
    value={value ? "true" : "false"}
    onChange={(e) => onChange(e.target.value === "true")}
  >
    <option value="false" title={fixedTitle}>Hologramme fixe</option>
    <option value="true" title={interactableTitle}>Hologramme manipulable</option>
  </select>
);

HologramModeSelect.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  fixedTitle: PropTypes.string,
  interactableTitle: PropTypes.string,
};

export default HologramModeSelect;
